function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForbidden = function SvgForbidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5 9a4 4 0 100-8 4 4 0 000 8zM2.172 7.827l5.656-5.655",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgForbidden;